/* eslint-disable */
import VueStoreService from './VueStoreService';

const ImportExcelService = {
  async listItems(url, store) {
    const resp = await VueStoreService.get('import-excel/items' + (url || ''), store);
    return resp; 
  },

  async listBatches(store) {
    const resp = await VueStoreService.get('import-excel/batches', store);
    return resp;
  },

  async uploadExcel(file, store) {
    const form = new FormData();
    form.append('file', file);
    const resp = await VueStoreService.postFile('import-excel/upload', form, store);
    return resp;
  },

  async softDeleteBatch(id, store) {
    return await VueStoreService.delete(`import-excel/batches/${id}`, store);
  },
};

export default ImportExcelService;